import React from 'react';
import PropTypes from 'prop-types';
import Dialog, {
  DialogActions,
  DialogContent,
  withMobileDialog,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import SanitizedHtml from '../../SanitizedHtml';

const InvestorKycDialog = ({
  fullScreen,
  managementTeamMember,
  toggleManagementTeamDialog,
}) => {
  const { fullName, position, biography, imageUrl } = managementTeamMember;

  return (
    <Dialog
      fullScreen={fullScreen}
      open={Boolean(managementTeamMember)}
      onClose={() => toggleManagementTeamDialog(null)}
    >
      <DialogContent>
        <div className='modal-title-container w-clearfix'>
          <div className='modal-exec-label w-clearfix'>
            <div
              className='exec-thumbnail'
              style={{
                backgroundImage: `url(${
                  imageUrl || '/images/default-issuer.png'
                })`,
              }}
            />
            <div className='_16-black-label'>{position}</div>
            <h2 className='team-name'>{fullName}</h2>
          </div>
          <div className='modal-paragraph'>
            <SanitizedHtml html={biography || 'No bio available'} />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => toggleManagementTeamDialog(null)}
          className='action-button'
          disableRipple
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InvestorKycDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  managementTeamMember: PropTypes.object.isRequired,
  toggleManagementTeamDialog: PropTypes.func.isRequired,
};

export default withMobileDialog({
  breakpoint: 'xs',
})(InvestorKycDialog);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ManagementTeam/ManagementTeamDialog.js